/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_launchpad__cost_notification = /** @type {(inputs: {}) => string} */ () => {
	return `Geben Sie einen Start und ein Ziel ein, um die detaillierten Kosten der Route zu sehen`
};

const en_launchpad__cost_notification = /** @type {(inputs: {}) => string} */ () => {
	return `Enter a departure and an arrival to see the detailed cost of the itinerary`
};

const es_launchpad__cost_notification = /** @type {(inputs: {}) => string} */ () => {
	return `Introduzca una salida y una llegada para ver los detalles del coste de la ruta`
};

const fr_launchpad__cost_notification = /** @type {(inputs: {}) => string} */ () => {
	return `Entrez un départ et une arrivée pour voir le détail du coût de l’itinéraire`
};

const it_launchpad__cost_notification = /** @type {(inputs: {}) => string} */ () => {
	return `Inserire una partenza e un arrivo per visualizzare i dettagli del costo del percorso`
};

const nl_launchpad__cost_notification = /** @type {(inputs: {}) => string} */ () => {
	return `Voer een vertrek- en aankomstpunt in om de details van de kosten van de route te zien`
};

const pt_launchpad__cost_notification = /** @type {(inputs: {}) => string} */ () => {
	return `Introduza uma partida e uma chegada para ver pormenores sobre o custo do itinerário`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__cost_notification = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.launchpad__cost_notification(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("launchpad__cost_notification", locale)
	if (locale === "de") return de_launchpad__cost_notification(inputs)
	if (locale === "en") return en_launchpad__cost_notification(inputs)
	if (locale === "es") return es_launchpad__cost_notification(inputs)
	if (locale === "fr") return fr_launchpad__cost_notification(inputs)
	if (locale === "it") return it_launchpad__cost_notification(inputs)
	if (locale === "nl") return nl_launchpad__cost_notification(inputs)
	return pt_launchpad__cost_notification(inputs)
};